import { render, staticRenderFns } from "./LicenseItem.vue?vue&type=template&id=3b2ddc0c&scoped=true&"
import script from "./LicenseItem.vue?vue&type=script&lang=js&"
export * from "./LicenseItem.vue?vue&type=script&lang=js&"
import style0 from "./LicenseItem.vue?vue&type=style&index=0&id=3b2ddc0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2ddc0c",
  null
  
)

export default component.exports